import { useLocation, useNavigate } from 'react-router-dom'
import { isNil } from 'lodash'
import { useCallback } from 'react'

export default function useQueryParamSetter() {
    const location = useLocation()
    const navigate = useNavigate()

    const setQueryParam = useCallback(
        params => {
            const searchParams = new URLSearchParams(location.search)

            Object.keys(params).forEach(key => {
                const value = params[key]
                if (value === '' || isNil(value)) {
                    searchParams.delete(key)
                } else if (Array.isArray(value)) {
                    if (value.length) {
                        searchParams.set(key, value.join(','))
                    } else {
                        searchParams.delete(key)
                    }
                } else {
                    searchParams.set(key, value)
                }
            })

            const newSearch = searchParams.toString()

            navigate(
                {
                    pathname: location.pathname,
                    search: `?${newSearch}`,
                },
                { replace: true },
            )

            return location
        },
        [location, navigate],
    )

    return setQueryParam
}
